export default [
    {
        path: '/editpassword',
        name: 'editpassword',
        component: () => import('@/views/pages/editpassword/editpassword.vue'),
        meta: {
          pageTitle: '修改密碼',
          breadcrumb: [
            {
              text: '修改密碼',
              active: true,
            },
          ],
          keepAlive: true // 需要被缓存
  
        },
      },
  ]